'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * export for testing purposes
 */
var DefaultLoadErrorView = function DefaultLoadErrorView(_ref) {
  var model = _ref.model;
  return _react2.default.createElement(
    'div',
    null,
    'Can\'t load model `',
    model.className,
    '` with id `',
    model.id,
    '`'
  );
};

/**
 * render view from `loadingViewFactory` if model fetch in progress
 * render view from `loadErrorViewFactory` if model fetch failed
 * render view from `children` if model fetch success
 */

var WithInitializedModel = function (_Component) {
  _inherits(WithInitializedModel, _Component);

  function WithInitializedModel() {
    _classCallCheck(this, WithInitializedModel);

    return _possibleConstructorReturn(this, (WithInitializedModel.__proto__ || Object.getPrototypeOf(WithInitializedModel)).apply(this, arguments));
  }

  _createClass(WithInitializedModel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          model = _props.model,
          children = _props.children,
          LoadingView = _props.loadingViewFactory,
          ErrorView = _props.loadErrorViewFactory;

      var backendSyncState = model.getBackendSyncState();

      if (backendSyncState.fetchInProgress) {
        return _react2.default.createElement(LoadingView, { model: model });
      }

      if (backendSyncState.fetchError) {
        return _react2.default.createElement(ErrorView, { model: model });
      }

      return children(model);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      this._onChange = function () {
        return _this2.setState({ lastUpdate: new Date() * 1 });
      };
      var model = this.props.model;

      var backendSyncState = model.getBackendSyncState();

      model.on(model.triggerWhenChanged, this._onChange);
      backendSyncState.on(backendSyncState.triggerWhenChanged, this._onChange);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this._onChange) {
        return;
      }
      var model = this.props.model;

      var backendSyncState = model.getBackendSyncState();

      model.off(model.triggerWhenChanged, this._onChange);
      backendSyncState.off(backendSyncState.triggerWhenChanged, this._onChange);
    }
  }]);

  return WithInitializedModel;
}(_react.Component);

WithInitializedModel.propTypes = {
  model: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.func.isRequired,
  loadingViewFactory: _propTypes2.default.func,
  loadErrorViewFactory: _propTypes2.default.func
};
WithInitializedModel.defaultProps = {
  loadingViewFactory: function loadingViewFactory() {
    return null;
  },
  loadErrorViewFactory: DefaultLoadErrorView
};
exports.default = WithInitializedModel;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/WithInitializedModel.js
// module id = 711
// module chunks = 118